<template>
  <b-modal
    ref="addName"
    v-model="showModal"
    :title="title"
    ok-variant="success"
    cancel-title="Mégsem"
    :ok-disabled="!nameState || checking"
    @ok="saveSegment"
  >
    <b-form-group
      :state="error.length === 0"
      label="Név"
      label-for="name-input"
      :invalid-feedback="error"
    >
      <b-form-input
        id="name-input"
        v-model="name"
        :state="nameState"
        required
      />
    </b-form-group>
    <template v-slot:modal-ok>
      <span class="mr-1">Mentés</span>
      <b-spinner
        v-show="checking"
        small
        variant="light"
        label="Mentés"
      />
    </template>
  </b-modal>
</template>
<script>
  export default {
    props: {
      show: {
        type: Boolean,
        required: true,
      },
      title: {
        type: String,
        required: true
      },
      names: {
        type: Set,
        required: true
      }
    },
    data() {
      return {
        showModal: false,
        checking: false,
        error: 'A név megadása kötelező',
        name: '',
      }
    },
    computed: {
      nameState() {
        return this.error.length === 0
      }
    },
    watch: {
      showModal: function(show) {
        this.name = ''
        this.$emit('update:show', show)
      },
      show: function(show) {
        this.showModal = show
      },
      name(name) {
        if(name.length === 0) {
          this.error = 'A név megadása kötelező'
        } else if(this.names.has(name)) {
          this.error = 'Már létezik szegmens ilyen néven'
        } else {
          this.error = ''
        }
      }
    },
    mounted() {
      this.showModal = this.show
    },
    methods: {
      saveSegment() {
        this.$emit('add', this.name)
      },
    }
  }
</script>